import React from "react";
import { Grid, Text, Button, Icons, Card } from "@pushpress/shared-components";
import { useAnalytics } from "../../components/providers/AnalyticsProvider";
import { CommittedClubEvent } from "./CommittedClubEvents";

type CommitedClubAboutPanelProps = {
  isClubSetup: boolean;
  hasLaunched: boolean;
};

const CommitedClubAboutPanel = (props: CommitedClubAboutPanelProps) => {
  const { isClubSetup, hasLaunched } = props;
  const { trackEvent } = useAnalytics();

  const openBestPracticeGuide = () => {
    trackEvent(CommittedClubEvent.BestPracticeGuideSelected, {
      app: "committed_club",
      page: `committed_club_dashboard`,
      live_now: isClubSetup,
      state: hasLaunched ? "launched" : "pre_launch",
    });
    window.open(
      "https://www.pushpress.com/products/core/committed-club/best-practices",
      "_blank",
    );
  };

  return (
    <Grid item xs={12} md={4}>
      <Card>
        <Card.Content>
          <div className="tw-py-4">
            <Text variant="heading-5">
              Committed Club is a monthly consistency club that requires a
              member to check-in a certain number of times per month to make it
              in to that month’s committed club.
            </Text>
            <div className="tw-h-8" />
            <Button
              text="What will members see?"
              buttonType="text"
              icon={Icons.ArrowRight}
              iconLocation="right"
              size="medium"
              target="_blank"
              href="https://help.pushpress.com/en/articles/10176709-member-app-committed-club"
            />
            <div className="tw-h-2" />

            <Button
              text="What will I see in Core?"
              buttonType="text"
              icon={Icons.ArrowRight}
              iconLocation="right"
              size="medium"
              target="_blank"
              href="https://help.pushpress.com/en/articles/10176615-core-committed-club-dashboard-set-up#h_7271163445"
            />

            <div className="tw-h-6" />

            <Card className="tw-mb-6">
              <Card.Content>
                <div className="tw-flex tw-flex-col tw-gap-1">
                  <Button
                    text="Best-Practice Guide"
                    buttonType="text"
                    size="medium"
                    icon={Icons.NewPage}
                    iconLocation="right"
                    onClick={openBestPracticeGuide}
                  />
                  <Text variant="body-lg">
                    Learn about how to to run an effectives Committed Club at
                    your gym - covering topics like communications, monthly and
                    annual prizes, and more.
                  </Text>
                </div>
              </Card.Content>
            </Card>
          </div>
        </Card.Content>
      </Card>
    </Grid>
  );
};

export default CommitedClubAboutPanel;
